export default __webpack_public_path__ + "static/media/logo.c8e5f541.png";